/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_All_After_LabelInputs */



/**
* | output |
* | --- |
* | "Select all events after the current selection" |
*
* @param {Context_Menu_Select_All_After_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all_after_label = /** @type {((inputs?: Context_Menu_Select_All_After_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_All_After_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez tous les événements postérieurs à la sélection actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie alle Ereignisse nach der aktuellen Auswahl aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutti gli eventi successivi alla selezione corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите все события после текущего выбора")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione todos los eventos después de la selección actual.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择当前选择之后的所有事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の選択範囲以降のすべてのイベントを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान चयन के बाद के सभी इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione todos os eventos após a seleção atual.")
	return /** @type {LocalizedString} */ ("Select all events after the current selection")
});